import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { PopupServiceCancel } from '../../../../../app.common/modules/common/models/popupServiceCancel';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { IUser } from '../../../account/model';
import { Store } from '../../../core';
import { IRetailerRootScope } from '../../../core/models';
import { Open360BusinessLogicRetailersStoresBEStore } from '../../../model/open360BusinessLogicRetailersStoresBEStore';
import { ShopService } from '../../shop.service';

interface IManagerShop {
    openForm: {
        openingHours: boolean;
        store: boolean;
    };
    store: Store;
    isNew: boolean;
    isShowInventory: () => boolean;
}

export class ShopController {
    public static $inject = ['$scope', '$state', 'shopService', 'popupService', 'notificationService', '$translate', '$rootScope'];
    public waiting: boolean = false;
    public manager: IManagerShop;
    public shopID: number = null;
    public businessTypeEnum = Open360BusinessLogicRetailersStoresBEStore.BusinessTypeEnum;
    public isNfrnRetailer: boolean;

    constructor(
        $scope: ng.IScope,
        private $state: StateService,
        private shopService: ShopService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private $rootScope: IRetailerRootScope,
    ) {
        const id = parseInt($state.params.id, 10);
        this.shopID = null;
        if (!isNaN(id)) {
            this.shopID = id;
        }
        this.manager = {
            openForm: {
                openingHours: false,
                store: false,
            },
            store: null,
            isNew: this.shopID == null,
            isShowInventory: () => {
                if (this.manager.store) {
                    return this.shopService.isShowInventory(this.manager.store.BusinessType);
                }
                return false;
            }
        };
        $scope.$on('openOpeningHours', (event, isOpen) => {
            this.manager.openForm.openingHours = isOpen;
        });

        $scope.$on('openStore', (event, isOpen) => {
            this.manager.openForm.store = isOpen;
        });

        $scope.$on('setStore', (event, store) => {
            this.manager.store = store;
        });

        const unwatch = $rootScope.$watch('userData', async (userData: IUser) => {
            if (userData.permission) {
                unwatch();
                this.isNfrnRetailer = userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn;
            }
        }, true);
    }

    public archiveStore = async () => {
        try {
            await this.popupService.confirm({
                title: this.$translate.instant('archive_place'),
                content: `<p>${this.$translate.instant('archive_place_confirm')}</p>`,
                cancelClass: 'btn-success',
                okTxt: this.$translate.instant('no'),
                cancelTxt: this.$translate.instant('yes'),
                invertAction: true
            });
            this.notificationService.showWaitingMessage();
            this.waiting = true;

            this.shopService.archiveStore(this.shopID).then((response) => {
                this.$state.go('app.shops');
            });
        } catch (error) {
            if (!PopupServiceCancel.isCancelOrBackdropClickInstance(error)) {
                this.notificationService.showErrorMessage(error);
            }
        }
        this.waiting = false;
    }
}

angular.module('naut').component('shop', {
    template: require('./shop.html'),
    controller: ShopController,
    controllerAs: 'vm'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/components/shop/shop.component.ts